// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap--xRd2T","wrapRight":"wrapRight--lhsfu","borderBox":"borderBox--BMM5J","image":"image--0lUjV","cardContent":"cardContent--0wm1F"};